import {Inject, Injectable} from '@angular/core';
import { Client, ClientOptions } from '@pusher/push-notifications-web';
import {EchoChannelService} from "./echo-channel.service";
@Injectable({
  providedIn: 'root'
})
export class PushNotifService {
  beamsClient: Client;
  erviceNotif = Inject(EchoChannelService)
  constructor() {
    try {
      this.erviceNotif.get
      const options: ClientOptions = {
        instanceId: '60cd507b-4e99-4d95-962a-d67d888b0dd1',
      }
      this.beamsClient = new Client(options);
    } catch (e) {
      console.error('Error in constructor', e);
      // Handle the error here
    }
  }
  async  Start(data : any){
    // console.log('data data',data)
    try {
      await this.beamsClient.start()
      await this.beamsClient.setDeviceInterests(data)
      console.log('Successfully registered with Beams');
    } catch (e) {
      console.error('Could not register with Beams', e);
    }
  }
}
